import { giphyBlue } from '@giphy/colors'
import styled, { css, keyframes } from 'styled-components'
import { BORDER_RADIUS_MEDIUM } from '../../constants'
import { ArtboardCornerPosition } from './types'

const BORDER_SIZE = 3

const borderAnimation = keyframes`
    0% { background-position: 0 0, 100% 100%, 0 100%, 100% 0; }
    100% { background-position: 16px 0, calc(100% - 16px) 100%, 0 calc(100% - 16px), 100% 16px; }
`

const getResizeHandlePosition = (position: ArtboardCornerPosition) => {
    switch (position) {
        case ArtboardCornerPosition.BottomLeft:
            return `bottom: 0; left: 0; transform: rotate(90deg);`
        case ArtboardCornerPosition.BottomRight:
            return `bottom: 0; right: 0;`
        case ArtboardCornerPosition.TopLeft:
            return `top: 0; left: 0; transform: rotate(180deg);`
        case ArtboardCornerPosition.TopRight:
            return `top: 0; right: 0; transform: rotate(-90deg);`
    }
}

export const Draggable = styled.div<{ selected: boolean }>`
    border-radius: ${BORDER_RADIUS_MEDIUM}px;
    box-shadow: 0 0 0 ${BORDER_SIZE}px rgba(0, 0, 0, 0);
    box-sizing: content-box;
    cursor: grab;
    overflow: visible;
    position: absolute;
    transition: box-shadow 0.1s ease-out;
    user-select: none;

    &:active {
        cursor: grabbing;
    }

    ${({ selected }) =>
        !selected &&
        css`
            &:hover {
                box-shadow: 0 0 0 ${BORDER_SIZE}px ${giphyBlue};
            }
        `}
`

export const RotateHandle = styled.div`
    background: #fff;
    bottom: 100%;
    filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.3));
    height: 5px;
    left: 50%;
    margin-bottom: ${BORDER_SIZE}px;
    position: absolute;
    width: ${BORDER_SIZE}px;

    &:after {
        border: 3px solid #fff;
        border-radius: 50%;
        box-sizing: border-box;
        content: '';
        height: 16px;
        left: 50%;
        margin-left: -8px;
        position: absolute;
        top: -16px;
        width: 16px;
    }
`

export const ResizeHandle = styled.div<{ position: ArtboardCornerPosition }>`
    box-shadow: inset -7px -7px 0 #fff;
    filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.3));
    height: 21px;
    position: absolute;
    width: 21px;
    ${({ position }) => getResizeHandlePosition(position)}

    &:after {
        background: #fff;
        bottom: 0;
        content: '';
        height: 14px;
        position: absolute;
        right: 0;
        width: 14px;
    }
`

export const SelectedBorder = styled.div`
    animation: ${borderAnimation} 0.5s linear infinite;
    background: linear-gradient(90deg, #fff 50%, transparent 50%), linear-gradient(90deg, #fff 50%, transparent 50%),
        linear-gradient(0deg, #fff 50%, transparent 50%), linear-gradient(0deg, #fff 50%, transparent 50%);
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    background-size: 16px ${BORDER_SIZE}px, 16px ${BORDER_SIZE}px, ${BORDER_SIZE}px 16px, ${BORDER_SIZE}px 16px;
    background-position: 0 0, 100% 100%, 0 100%, 100% 0;
    border-radius: inherit;
    bottom: -${BORDER_SIZE}px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    left: -${BORDER_SIZE}px;
    position: absolute;
    right: -${BORDER_SIZE}px;
    top: -${BORDER_SIZE}px;
`

export const SnapGuideHorizontal = styled.div`
    background: ${giphyBlue};
    height: 100%;
    margin-left: -1px;
    position: absolute;
    top: 0;
    width: 2px;
`

export const SnapGuideVertical = styled.div`
    background: ${giphyBlue};
    height: 2px;
    left: 0;
    margin-top: -1px;
    position: absolute;
    width: 100%;
`
